import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Idea from '../images/idea.svg'
import link from '../images/link.svg'
import tags from '../images/settings.svg'
import Img from 'gatsby-image'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
const PortfolioTemplate = ({ data, location, pathContext }) => {
  const { markdownRemark: post } = data
  const { frontmatter, html } = post
  const { title, homepage } = frontmatter
  return (
    <div>
      <Helmet title={`Portfolio ${title} - ${data.site.siteMetadata.title}`} />
      <div className="project-wrapper animated fadeIn">
        <div className="main-wrapper">
          <h1>{frontmatter.title}</h1>
          <div className="project">
            <div className="project-image">
              <Img
                sizes={frontmatter.featuredImage.childImageSharp.sizes}
                className="thumbnail"
              />
            </div>
            <div className="data-wrapper">
              <div className="data-sections">Description</div>
              <div className="description">
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>
              <div className="data-sections">Tecnology</div>
              <div className="tag-list">
                <ul>
                  <li>
                    <img src={tags} alt="" />
                  </li>
                  {frontmatter.tags.map(tag => {
                    return (
                      <li key={tag}>
                        <div className="a-animation standout">{tag}</div>
                      </li>
                    )
                  })}
                </ul>
              </div>
              <div className="data-sections">Link</div>
              <div className="link">
                <img src={link} alt="" />
                <OutboundLink
                  href={frontmatter.homepage}
                  target="_blank"
                  className="a-animation"
                >
                  {frontmatter.homepage}
                </OutboundLink>
              </div>
              <div className="data-sections">Type</div>
              <div className="link">{frontmatter.type}</div>
            </div>
          </div>
          <div className="back">
            <Link to="/lab" className="a-animation">
              Back to the lab
            </Link>
          </div>
          <div className="subtitle content">
            Do you have an idea?
            <img src={Idea} alt="Phanor Coll" />
            <Link className="a-animation standout bottomLink" to="/contact">
              contact me
            </Link>{' '}
            and lets bring it to life.
          </div>
        </div>
      </div>
    </div>
  )
}

export const pageQuery = graphql`
  query PortfolioByPath($path: String) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
        path
        tags
        homepage
        type
        featuredImage {
          childImageSharp {
            sizes {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        author
      }
    }
  }
`

export default PortfolioTemplate



// WEBPACK FOOTER //
// ./src/templates/portfolio.js